module.exports = "/_next/static/images/case-list-329bb7c90981c34b9fdd952716191dda.png";